
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, LogIn, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { ModeToggle } from "@/components/theme/ModeToggle";
import MobileNav from "./MobileNav";

const Header = () => {
  const { user, signOut } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const headerClasses = isHome
    ? "absolute top-0 left-0 w-full z-30 bg-transparent  border-white/10 py-4 text-white"
    : "relative z-20 bg-[#05111e] border-b border-white/10 py-4 text-white";

  return (
    <header className={headerClasses}>

      <div className="container mx-auto px-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <span className="font-display font-bold text-2xl text-white">
            Lex<span className="text-[#D4AF37]">Prompt</span>
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          <Link to="/" className="text-white hover:text-[#D4AF37] transition-colors font-medium">Home</Link>
          <Link to="/pricing" className="text-white/90 hover:text-[#D4AF37] transition-colors font-medium">Preços</Link>
          <Link to="/about" className="text-white/90 hover:text-[#D4AF37] transition-colors font-medium">Sobre</Link>
          <Link to="/features" className="text-white/90 hover:text-[#D4AF37] transition-colors font-medium">Funcionalidades</Link>
        </nav>

        {/* Desktop Auth Buttons and Theme Toggle */}
        <div className="hidden md:flex items-center space-x-4">
          <ModeToggle />

          {user ? (
            <>
              <Button
                asChild
                variant="ghost"
                className="text-white hover:text-[#D4AF37] hover:bg-white/10 transition-colors font-medium"
              >
                <Link to="/dashboard">
                  Dashboard
                </Link>
              </Button>
              <Button
                onClick={() => signOut()}
                variant="outline"
                className="border-white/30 text-white hover:bg-white/10 bg-transparent"
              >
                Sair
              </Button>
            </>
          ) : (
            <>
              <Button
                asChild
                variant="ghost"
                className="text-white hover:text-[#D4AF37] hover:bg-white/10 transition-colors font-medium"
              >
                <Link to="/auth/login" className="flex items-center">
                  <LogIn className="mr-2 h-4 w-4" />
                  Login
                </Link>
              </Button>
              <Button
                asChild
                className="bg-[#D4AF37] hover:bg-[#BFA02A] text-[#072A45] font-semibold transition-colors border-0"
              >
                <Link to="/auth/register" className="flex items-center">
                  <UserPlus className="mr-2 h-4 w-4" />
                  Registrar
                </Link>
              </Button>
            </>
          )}
        </div>


        {/* Mobile Menu Button and Theme Toggle */}
        <div className="md:hidden flex items-center space-x-2">
          <ModeToggle />
          <Button
            onClick={toggleMobileMenu}
            variant="ghost"
            size="icon"
          >
            {mobileMenuOpen ? <X /> : <Menu />}
          </Button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {mobileMenuOpen && (
        <MobileNav closeMobileMenu={closeMobileMenu} />
      )}
    </header>
  );
};

export default Header;
